import { skipToken, useQuery } from '@tanstack/react-query';

import { AddOns } from '@air/api';
import { type Workspace } from '@air/api/types';
import { ONE_HOUR } from '@air/utilities';

export const WORKSPACE_ADDONS_KEY = '@plugin-ui/WORKSPACE_ADDONS';
export const getWorkspaceAddOnsKey = (params: UseWorkspaceAddOnsParams) => [WORKSPACE_ADDONS_KEY, params];

export type UseWorkspaceAddOnsParams = {
  workspaceId: Workspace['id'] | undefined;
};

export const useWorkspaceAddOns = ({ workspaceId }: UseWorkspaceAddOnsParams) =>
  useQuery({
    queryFn: workspaceId ? () => AddOns.list({ workspaceId }) : skipToken,
    queryKey: getWorkspaceAddOnsKey({ workspaceId }),
    staleTime: ONE_HOUR,
  });
